
export const tableHeadStyles = {
  borderLeft: '1px solid #eceeef',
  borderRight: '1px solid #eceeef',
  borderBottom: '1px solid #eceeef',
  background: 'whitesmoke',
  padding: '.3em'
};

export const thStyles = {
  padding: '.35em'
};

export const thSpanStyles = {
  fontSize:'14px',
  fontWeight: '400',
  paddingRight:'.75em',
  float:'right'
};

export const lastThSpanStyles = {
  ...thSpanStyles,
  float: 'left'
};

export const lastTdStyles = {
  width: '10rem'
};

export const middleThStyles = {...thStyles};

